import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { RoomType } from '../models';

@Injectable({ providedIn: 'root' })
export class RoomTypesApiService {
  private readonly http = inject(HttpClient);

  public query() {
    return this.http.get<RoomType[]>(`${environment.restEndpoint}/roomTypes`);
  }
}
